import $http from '../../axios';
import {Notification} from 'element-ui';

export async function fetchQuotations({commit, state}, parameters = {params: state.params}) {
    commit('setPreloader', true);
    await $http.get('/api/documentos-por-tipo-de-comprobante', parameters)
        .then((response) => {
            commit('setQuotations', response.data.data);
            commit('setPreloader', false);
        }).catch((error) => {
            commit('setPreloader', false);
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });

}

export async function quotationToCart({commit, state}, id) {
    await $http.post('/api/cotizacion-a-carrito/' + id)
        .then((response) => {
            return true;
        }).catch((error) => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

//Obtener los lineas
export async function reportGenerate({commit, state, dispatch}, requestParameters = {params: state.params}) {
    await $http.get('/api/reporte-pedidos', requestParameters)
        .then((response) => {
            dispatch('downloadDocument', response.data.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error generando el informe',
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('lineError', error.message);
        });
}

export async function downloadDocument({}, documentObject) {
    await $http({
        url: '/storage/reports/' + documentObject,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', documentObject);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    });
}

export async function getSellers({commit}) {

    commit('setSellerIdParams', null);

    await $http.get('/api/lista-vendedores').then(response => {
        commit('setSellers', response.data.data);
    }).catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        }
    );
}

export async function softDeleteDocumentCot({commit}, document_id) {

    await $http.delete(`/api/eliminar-documento-softdelete/${document_id}`)
    .then(response => {
        Notification.success({
            title: 'Exito!',
            message: 'Cotizacion eliminada.',
            type: 'success',
            duration: 3000,
            customClass: 'notification-box'
        });
    }).catch(error => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box'
        });
    });
}



// WEBPACK FOOTER //
// ./src/modules/quotations/actions.js